import { For } from 'solid-js'
import { buildLocaleHref } from '../../../utils/locale-href.js'
import './footer-organism.scss'
import { useFooterOrganismComponentController } from './footer-organism-controller.js'
import ButtonAtomComponent from '../../atoms/button-atom/button-atom-component.jsx'
import { useIntl } from '@cookbook/solid-intl'
import { messages } from './footer-organism.messages.en.js'

export default function FooterOrganismComponent () {
    const intl = useIntl()
    const {
        footerSections,
        platformSection,
        handleFooterClick,
    } = useFooterOrganismComponentController()

    return (
        <div class="footer">
            <div class="footer__container">
                <div class="footer__sections">
                    <For each={footerSections()}>
                        {(section) => (
                            <div class="footer__section">
                                <div class="footer__section-title">
                                    {section.title}
                                </div>
                                <div class="footer__section-divider" />
                                <For each={section.links}>
                                    {(link) => (
                                        <div class="footer__link-wrapper">
                                            {/* Native anchor, not `LinkAtomComponent`: that atom
                                                renders `@solidjs/router`'s `A`, and the footer is
                                                rendered on the server for the prerendered location
                                                pages. External links keep their raw href; internal
                                                ones are locale-prefixed here, which the atom used
                                                to do. */}
                                            <a
                                                href={link.external ? link.href : buildLocaleHref(link.href, intl.locale)}
                                                class="footer__link"
                                                onClick={(event) => handleFooterClick(event, link)}
                                                {...(link.external && {
                                                    rel: 'noopener noreferrer',
                                                    target: '_blank',
                                                })}
                                            >
                                                {link.text}
                                            </a>
                                        </div>
                                    )}
                                </For>
                            </div>
                        )}
                    </For>
                </div>

                <div class="footer__platform">
                    <div class="footer__platform-contents">
                        <div class="footer__platform-logo">
                            <img src={platformSection().logo.src} alt={platformSection().logo.alt} />
                        </div>
                        <div class="footer__platform-description">
                            {platformSection().description}
                        </div>
                    </div>
                    <div class="footer__platform-buttons">
                        {/* An anchor, not a click handler: this footer is rendered to a string for
                            every prerendered landing page and never hydrated there, so a `<button>`
                            that called `window.open()` was inert on all 96 of them. The atom
                            renders an `<a>` when given an `href`, so the SPA opens the identical
                            URL in the identical new tab. [doc: verifier finding 3] */}
                        <ButtonAtomComponent
                            class="footer__platform-button"
                            href={platformSection().learnMoreHref}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            {intl.formatMessage(messages.learnMoreButton)}
                        </ButtonAtomComponent>
                    </div>
                </div>

                <p class="footer__legalese">
                    {intl.formatMessage(messages.legalese)}
                </p>
            </div>
        </div>
    )
}
